import { useIntl } from "react-intl";

import type { THotelRoom } from "@/features/hotels/types/types";

type HotelRoomTitleProps = Pick<THotelRoom, "name" | "board" | "occupancy">;

export const HotelRoomTitle = ({
  name,
  board,
  occupancy,
}: HotelRoomTitleProps) => {
  const intl = useIntl();

  return (
    <>
      {`${name} - ${board} - ${intl.formatMessage(
        {
          id: "hotels.search.visitorsSumWithTypes",
          defaultMessage:
            "{adultsCount, plural, one {# Adult} other {# Adults}}{childrenCount, plural, =0 {} other {, {childrenCount, plural, one {# Child} other {# Children}}}}",
        },
        {
          adultsCount: occupancy.numberOfAdults,
          childrenCount: occupancy.numberOfChildren,
        },
      )}
    `}
    </>
  );
};
